import React from 'react'

function Library() {
  return (
    <h1>Library</h1>
  )
}

export default Library